export default "__VITE_ASSET__D8gu7IP9__"